import { TanStackPostalCodeField } from "@sellar-io/components/adapters";
import { Button, H2 } from "@sellar-io/components";
import TagManager from "react-gtm-module";
import { useForm, useStore } from "@tanstack/react-form";
import { useMatch } from "react-router";
import { useLocalStorage } from "usehooks-ts";
import { useShallow } from "zustand/react/shallow";
import { InputLabel } from "@sellar-io/components";
import { NEW_VENUE } from "../../../../../constants/routes";
import { useEvents } from "../../../../../hooks";
import {
  BuyerCreationFlowStep,
  useBuyerCreationFlowStore,
} from "./BuyerCreationFlowStore";

export const BuyerCreationPostcodeStep = () => {
  const { setStep, setPostcode, postcode } = useBuyerCreationFlowStore(
    useShallow((state) => ({
      setStep: state.setStep,
      setPostcode: state.setPostcode,
      postcode: state.postcode,
    })),
  );
  const { track } = useEvents();

  const [unAuthorisedUserPostcode, setUnAuthorisedUserPostcode] =
    useLocalStorage<string | undefined>("unauthorisedUserPostcode", undefined);
  const isNewVenue = !!useMatch(NEW_VENUE);
  const form = useForm({
    defaultValues: { postcode: postcode ?? unAuthorisedUserPostcode ?? "" },
    onSubmit: async ({ value }) => {
      setPostcode(value.postcode);
      if (!isNewVenue) {
        setUnAuthorisedUserPostcode(value.postcode);
        await track("Postcode Entered");
        TagManager.dataLayer({
          dataLayer: { event: "postcode_entered", postcode: value.postcode },
        });
      }
      setStep(BuyerCreationFlowStep.BuyerBusinessMatchStep);
    },
  });
  const formPostcode = useStore(form.store, (state) => state.values.postcode);

  return (
    <div className={"flex h-full flex-col justify-center gap-4"}>
      <div className="flex flex-col gap-4">
        <div>
          <H2 className={"text-center"}>Your delivery address</H2>
          <p className={"text-center"}>
            If you have multiple sites, you can add them later
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <InputLabel>Enter postcode</InputLabel>
          <TanStackPostalCodeField
            form={form}
            name="postcode"
            country="GB"
            placeholder="SW1A 1AA"
          />
        </div>

        <Button
          disabled={!formPostcode}
          className={"w-full"}
          onClick={() => form.handleSubmit()}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
